import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from "@material-ui/core/Button";
import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export class ContactListPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            contactlist: [],
            selecteduserid: "",

            usersUsername: "",
            usersName: "",
            usersSurname: "",
            usersEmail: "",
            usersPhone: "",
            usersPermission: "",
            usersPassword: "",
            usersInstitution: "",

            usersUsernameCreate: "",
            usersNameCreate: "",
            usersSurnameCreate: "",
            usersEmailCreate: "",
            usersPhoneCreate: "",
            usersPermissionCreate: "",
            usersPasswordCreate: "",
            usersInstitutionCreate: "",

            usersUsernameUpdate: "",
            usersNameUpdate: "",
            usersSurnameUpdate: "",
            usersEmailUpdate: "",
            usersPhoneUpdate: "",
            usersPermissionUpdate: "",
            usersPasswordUpdate: "",
            isContactListUsersSoftDeleted: -1,
            usersInstitutionUpdate: "",

            loading: true,
            notAuthorized: true,

            isFetching: false,
        }

        this.refUserUpdate = React.createRef();
    }

    componentDidMount() {
        this.loadUsers();

        //var now = new Date();
        //var year = now.getFullYear();
        //var month = now.getMonth() + 1;
        //var day = now.getDate();
        //var hour = now.getHours();
        //var minute = now.getMinutes();
        //var second = now.getSeconds(); 

        //console.log("ContactListUsers" +
        //    now.getFullYear() +
        //    now.getMonth() +
        //    now.getDate() +
        //    now.getHours() +
        //    now.getMinutes() +
        //    now.getSeconds() +
        //    now.getMilliseconds() +
        //     ".xlsx");
    }

    handleChange = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value
                .replace(/cfcu/ig, 'CFCU')
                .replace(/nipac/ig, 'NIPAC')
                .replace(/eud/ig, 'EUD')
        });
    };

    handleChangeTitleCase = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        });
    };

    handleChangeIntegerOnly = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value.replace(/\D/, '') });
    };

    handleChangePhone = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();

        if (e.target.value.length <= 14) {
            await this.setState({ [e.target.name]: e.target.value.replace(/\D/, '') });
        }
    };

    handleChangeDate = (name, value) => {
        //console.log(name);
        //console.log(value);

        this.setState({ [name]: new Date(value) });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    loadUsers = async () => {

        await fetch(global.variables.API_USEROPERATIONS_LOADALLCONTACTLIST, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate == 2) {
                    this.setState({
                        loading: false,
                        notAuthorized: true
                    });
                } else {
                    this.setState({
                        contactlist: result.listofusers,
                        loading: false,
                        notAuthorized: false
                    });
                }
            });
    };

    createUser = async () => {

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_USEROPERATIONS_CREATECONTACTLISTITEM, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed! " + result.errormessage, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadUsers();
            });

        await this.setState({ isFetching: false });
    };

    updateUser = async () => {

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_USEROPERATIONS_UPDATECONTACTLISTITEM, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed! " + result.errormessage, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadUsers();
            });

        await this.setState({ isFetching: false });
    };

    handleSetUpdateFields = (userId) => {

        //console.log(this.state);

        for (var i = 0; i < this.state.contactlist.length; i++) {
            if (this.state.contactlist[i].idContactListUsers == userId) {
                this.setState({
                    usersidContactListUsers: userId,
                    usersNameUpdate: this.state.contactlist[i].LoginName,
                    usersSurnameUpdate: this.state.contactlist[i].LoginSurname,
                    usersUsernameUpdate: this.state.contactlist[i].LoginUsername,
                    usersEmailUpdate: this.state.contactlist[i].LoginEmail,
                    usersPhoneUpdate: this.state.contactlist[i].LoginPhoneNumber,
                    isContactListUsersSoftDeleted: this.state.contactlist[i].isContactListUsersSoftDeleted,
                    usersInstitutionUpdate: this.state.contactlist[i].LoginInstitution
                });

                window.scrollTo(0, this.refUserUpdate.current.offsetTop);
            }
        }


    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                return array[i];
            }
        }
        return ({ TypeId: "", TypeName: "" });
    };

    render() {

        //var userPermissionOptions = [
        //    { TypeId: 1, TypeName: "Administrator" },
        //    { TypeId: 2, TypeName: "Contractor" },
        //    { TypeId: 3, TypeName: "ROMIS User (Expert, QC, QA)" }
        //];

        var userStatusOptions = [
            { TypeId: 0, TypeName: "Active" },
            { TypeId: 1, TypeName: "Inactive" }
        ];

        const {
            users,
            contactlist,
            selecteduserid,

            usersUsername,
            usersName,
            usersSurname,
            usersEmail,
            usersPhone,
            usersPermission,
            usersPassword,
            usersInstitution,

            usersUsernameCreate,
            usersNameCreate,
            usersSurnameCreate,
            usersEmailCreate,
            usersPhoneCreate,
            usersPermissionCreate,
            usersPasswordCreate,
            usersInstitutionCreate,

            usersUsernameUpdate,
            usersNameUpdate,
            usersSurnameUpdate,
            usersEmailUpdate,
            usersPhoneUpdate,
            usersPermissionUpdate,
            usersPasswordUpdate,
            isContactListUsersSoftDeleted,
            usersInstitutionUpdate,

            isFetching

        } = this.state;

        if (this.state.loading) {
            return (
                <Grid container spacing={3} >
                    <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.loading ? "block" : "none" }}>
                        <CircularProgress /> Loading...
                    </Grid>
                </Grid>
            );
        } else if (this.state.notAuthorized) {
            return (
                <p>You are not authorized</p>
            );
        } else {
            return (
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="New Contact List Item" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Name : *"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersNameCreate}
                                    name="usersNameCreate"
                                />
                                <TextField
                                    label="Surname : *"
                                    placeholder="Surname"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersSurnameCreate}
                                    name="usersSurnameCreate"
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersEmailCreate}
                                    name="usersEmailCreate"
                                />
                                <TextField
                                    label="Telephone Number :"
                                    placeholder="Phone"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangePhone}
                                    value={usersPhoneCreate}
                                    name="usersPhoneCreate"
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersInstitutionCreate}
                                    name="usersInstitutionCreate"
                                />


                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} height="100%">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.createUser}
                            disabled={isFetching ? true : false}
                            fullWidth
                        >
                            Create New Contact
                    </Button>
                    </Grid>





                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Update Contact List Item" className='romis-card-header' />
                            <CardContent>

                                <MaterialTable
                                    columns={[
                                        { title: 'User Id', field: 'idContactListUsers', hidden: true },
                                        { title: 'Name', field: 'LoginName' },
                                        { title: 'Surname', field: 'LoginSurname' },
                                        { title: 'Institution', field: 'LoginInstitution' },
                                        { title: 'Mail Address', field: 'LoginEmail' },
                                        { title: 'Telephone Number', field: 'LoginPhoneNumber' },
                                    ]}
                                    data={this.state.contactlist}
                                    title="Contacts"
                                    actions={[
                                        //{
                                        //    icon: 'info',
                                        //    tooltip: 'Project Details',
                                        //    onClick: (event, rowData) => {
                                        //        this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                                        //    },
                                        //},
                                        {
                                            icon: 'info',
                                            tooltip: 'Edit User',
                                            onClick: (event, rowData) => {
                                                //this.props.history.push(`/missiondetails/${rowData.idMissionDetails}`);
                                                //this.setState({ selecteduserid: `${rowData.idContactListUsers}` });
                                                this.handleSetUpdateFields(`${rowData.idContactListUsers}`);
                                            },
                                        },
                                    ]}
                                    options={{
                                        actionsColumnIndex: -1
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} height="100%">
                        <Button
                            href={"/api/ReportGenerator/ExportContactListUsers/" + btoa(localStorage.getItem("authtoken"))}
                            variant="contained"
                            color="primary"
                            //onClick={this.updateUser}
                            disabled={isFetching ? true : false}
                            download="ContactListUsers.xlsx"
                            fullWidth
                        >
                            Download All Contacts as Excel
                        </Button>
                    </Grid>

                    <Grid item xs={12} height="100%" ref={this.refUserUpdate}>
                        <Card>
                            <CardHeader title="Contact List Item Details" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Name : *"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersNameUpdate}
                                    name="usersNameUpdate"
                                />
                                <TextField
                                    label="Surname : *"
                                    placeholder="Surname"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersSurnameUpdate}
                                    name="usersSurnameUpdate"
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersEmailUpdate}
                                    name="usersEmailUpdate"
                                />
                                <TextField
                                    label="Phone :"
                                    placeholder="Phone"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangePhone}
                                    value={usersPhoneUpdate}
                                    name="usersPhoneUpdate"
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersInstitutionUpdate}
                                    name="usersInstitutionUpdate"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.updateUser}
                            disabled={isFetching ? true : false}
                            fullWidth
                        >
                            Update Contact
                        </Button>
                    </Grid>
                </Grid >
            );
        }
    }
}





// WEBPACK FOOTER //
// ./src/pages/ContactListPage.js